<template>
    <div class="animated fadeIn">
        <b-card class="card-accent-info" header="Pessoas">
            <b-card-body>
                <b-row>
                    <b-col cols="auto" class="mr-auto">
    <!--
                        <b-form-group>
                            <b-button variant="outline-primary" :pressed.sync="tableSelectable">{{tableSelectable ? 'Desabilitar Seleção ' : 'Habilitar Seleção'}}</b-button>
                            &nbsp;
                            <b-button variant="outline-primary" v-show="tableSelectable" @click="selectAllRows">Selecionar todos</b-button>
                            &nbsp;
                            <b-button variant="outline-primary" v-shPersonDocumentComponentow="tableSelectable" @click="clearSelectedRows">Limpar seleção</b-button>
                        </b-form-group>
    -->
                    </b-col>
                    <b-col cols="auto" class="">
                        <b-form-group>
                            <b-button variant="vine" class="mr-1 btn-brand" @click="enableDisable()" v-show="tableSelectable"><i class="fa fa-toggle-on"></i><span>Alterar Status</span></b-button>
                            &nbsp;
                            <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)"><i class="fa fa-plus"></i><span>Nova Pessoa</span></b-button>
                        </b-form-group>
                    </b-col>
                </b-row>
    
    
                <b-row>
                    <b-col cols="auto">
                      <b-form-group>
                          <label for="company" style="font-size: 0.8em">Empresa</label>
                          <b-form-select id="company"
                            v-model="filters.companyId"
                            :plain="true"
                            :options="companyDDL"
                            @change="changeCompany()"
                            :value="[null,'c']">
                          </b-form-select>
                      </b-form-group>                    
                    </b-col>
                    <b-col cols="auto">
                        <b-form-group>
                            <label for="filter" style="font-size: 0.8em">Filtro</label>
                            <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro" @keyup="filterChanged"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="auto">
                      <b-form-group>
                          <label for="type" style="font-size: 0.8em">Tipo de cadastro</label>
                          <b-form-select id="type"
                            v-model="filters.typeId"
                            :plain="true"
                            :options="selectTypeDDL"
                            @change="refreshData()"
                            :value="[null,'c']">
                          </b-form-select>
                      </b-form-group>                    
                    </b-col>
                    <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
                        <b-form-group>
                            <p></p>
                            <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
                        </b-form-group>
                    </b-col>
                    <b-col cols="auto" class="">
                        <b-form-group>
                            <label for="perPage" style="font-size: 0.8em">Linhas</label>
                            <b-form-select v-model="perPage" id="perPage" :plain="true" :options="[5,10,20,50]">
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-table :items="filteredItems" :fields="fields" :select-mode="selectMode" responsive="sm" ref="selectableTable" selectable @row-selected="onRowSelected" :primary-key="primaryKey" :tbody-transition-props="transProps" sort-icon-left @row-clicked="rowClicked"
                    :per-page="perPage" :current-page="currentPage" :busy="isBusy" hover striped>
    
                    <template #table-busy>
                      <div class="text-center text-danger my-2">
                          <b-spinner class="align-middle"></b-spinner>
                          <strong>Carregando...</strong>
                      </div>
                </template>
                              
                <!-- Example scoped slot for select state illustrative purposes -->
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                                      <span aria-hidden="true">&check;</span>
                                      <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                        <span aria-hidden="true">&nbsp;</span>
                        <span class="sr-only">Not selected</span>
                    </template>
                </template>

                <template #cell(show_details)="row">
                    <b-row>
                        <b-col cols="auto" class="mr-auto">
                            <b-form-group>
                                <b-button size="sm" variant="primary" @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </template>
                              
                <template #row-details="row">
                    <b-card>
                        <b-row>
                            <b-col class="small"><i>Observações:</i><br>{{ row.item.notes }}</b-col>
                        </b-row>
                    </b-card>
                </template>

                <template v-slot:cell(name)="data">
                    <span class="small">[{{ data.item.id }}]</span> <b> {{ data.item.name }}</b><span v-show="data.item.alias && data.item.alias.length > 0"> - "{{ data.item.alias }}"</span>
                    <br>
                    <span class="small" v-show="(data.item.daten && data.item.daten.length > 0) || (data.item.genderCode && (data.item.genderCode=='M' || data.item.genderCode=='F'))">
                      Nascimento: {{ $utils.dateStringFormat(data.item.daten) }} 
                      <span v-show="data.item.genderCode && (data.item.genderCode=='M' || data.item.genderCode=='F')">{{ (data.item.daten && data.item.daten.length > 0) ? " | " : "" }}Gênero: {{ data.item.genderCode }}</span>
                      <br>
                    </span>
                    <span class="small" v-show="data.item.types && data.item.types.length > 0">
                      Tipos de cadastro: <span v-for="(t, index) in data.item.types" :key="index">{{ index > 0 ? ", " : "" }}{{ t.label }} </span>
                      <br>
                    </span>
                </template>

                <template v-slot:cell(contact)="data">
                  <b-row>
                    <b-col sm=3><span class="small">E-mail: </span></b-col>
                    <b-col><a :href="'mailto:' + data.item.email">{{ data.item.email }}</a></b-col>
                  </b-row>
                  <b-row>
                    <b-col sm=3><span class="small">Telefone: </span></b-col>
                    <b-col>{{ data.item.phone1 }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col sm=3><span class="small"></span></b-col>
                    <b-col>{{ data.item.phone2 }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col sm=3><span class="small"></span></b-col>
                    <b-col>{{ data.item.phone3 }}</b-col>
                  </b-row>
                </template>

                <template v-slot:cell(st)="data">
                    <c-switch class="" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" />
                </template>
                              
                <template v-slot:cell(ispublic)="data">
                    <c-switch class="" color="primary" :checked="data.item.ispublic==1" label variant="pill" v-bind="switchLabelIcon" />
                </template>
              
          </b-table>
          <nav>
              <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
          </nav>


      </b-card-body>
    </b-card>

      <b-modal
            v-model="editModal"
            id="edit-modal"
            centered
            hide-footer
            title="Pessoa"
            size="xl">

            <b-nav fill>
            <b-nav-item :active="tabInfo=='P'" @click="tabInfo='P'">Pessoa</b-nav-item>
            <b-nav-item :active="tabInfo=='A'" @click="tabInfo='A'">Endereços</b-nav-item>
            <b-nav-item :active="tabInfo=='D'" @click="tabInfo='D'">Documentos</b-nav-item>
            <b-nav-item :active="tabInfo=='O'" @click="tabInfo='O'" v-show="selectedItem && selectedItem.personLawTypeId == 'F'">Dados Pessoais</b-nav-item>
            <b-nav-item :active="tabInfo=='M'" @click="tabInfo='M'" v-show="selectedItem && selectedItem.personLawTypeId == 'F'">Dados Médicos</b-nav-item>
            <b-nav-item :active="tabInfo=='R'" @click="tabInfo='R'" v-show="selectedItem && selectedItem.personLawTypeId == 'F'">Religião</b-nav-item>
          </b-nav>

          <div class="text-right mt-2">
            <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="closeEditModal()"><i class="fa fa-window-close"></i><span>Fechar</span></b-button>
          </div>

        <!-- Dados da Pessoa -->
        <div v-show="tabInfo=='P'">
            <person-component :item="selectedItem" :typeDDL="typeDDL" :personTypeDDL="personTypeDDL" :companyId="filters.companyId" @resp="handleResp"></person-component>
        </div>

        <div v-show="tabInfo=='A'">
            <person-address-component :item="selectedItem"></person-address-component>
          </div>

        <div v-show="tabInfo=='D'">
            <person-document-component :item="selectedItem"></person-document-component>
        </div>

        <div v-show="tabInfo=='M'">
          <person-medical-data-component :item="selectedItem" @resp="handleResp"></person-medical-data-component>
        </div>

        <div v-show="tabInfo=='R'">
          <person-religion-data-component :item="selectedItem" @resp="handleResp"></person-religion-data-component>
        </div>

        <div v-show="tabInfo=='O'">
          <person-personal-data-component :item="selectedItem" @resp="handleResp"></person-personal-data-component>          
        </div>


    </b-modal>

  </div>

</template>

<script>
import Vue from 'vue'
import axios from "axios";
import MaskedInput from 'vue-text-mask'
import vSelect from 'vue-select'
import PersonComponent from './PersonComponent'
import PersonAddressComponent from './PersonAddressComponent'
import PersonDocumentComponent from './PersonDocumentComponent'
import PersonMedicalDataComponent from './PersonMedicalDataComponent'
import PersonPersonalDataComponent from './PersonPersonalDataComponent'
import PersonReligionDataComponent from './PersonReligionDataComponent'

import { Switch as cSwitch } from '@coreui/vue'

/* Toast */
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr' // https://github.com/se-panfilov/mini-toastr
//import { table } from 'console'

const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
}

miniToastr.init({ types: toastTypes })

function toast({ title, message, type, timeout, cb }) {
    return miniToastr[type](message, title, timeout, cb)
}

const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
}
VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options)
/* Toast - End */


export default {
    name: 'tables',
    components: {
        Event,
        cSwitch,
        MaskedInput,
        vSelect,
        PersonAddressComponent,
        PersonDocumentComponent,
        PersonMedicalDataComponent,
        PersonPersonalDataComponent,
        PersonReligionDataComponent,
        PersonComponent
    },
    data: () => {
        return {            
            newItem: { id: null, name: '', personLawTypeId: 'F', genderCode: 'I', description: '', st: 'A', _rowVariant: '', types: null },
            // Tabela Documento
            typeDDL: [],
            companyDDL: [],
            personTypeDDL: [],

            tabInfo: 'P',
            isBusy: false,
            currentPage: 1,
            switchLabelIcon: {
                dataOn: '\u2713',
                dataOff: '\u2715'
            },
            switchLabelTxt: {
                dataOn: 'yes',
                dataOff: 'no'
            },

            //tableRef: "table",
            tableSelectable: false,

            editModal: false,

            filters: {
              companyId: 0,
              key: '',
              typeId: 0
            },

            modes: ['multi', 'single', 'range'],
            selectMode: 'multi',
            selected: [],
            transProps: {
                // Transition name
                name: 'flip-list'
            },
            primaryKey: "id",

            selectedItem: {},
            items: [],
            fields: [
                {key: 'show_details', label: "", thStyle: { width: "40px" } },
                //{key: 'id' },
                { key: 'name', label: 'Nome', sortable: true },
                { key: 'contact', label: 'Contato', sortable: false, thStyle: { width: "400px" } },
                //{key: 'ispublic', label: 'Público', sortable: true, thStyle: { width: "40px" } },
                { key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" } }
            ],

            filterable: ['username'],
            sortIcon: { base: 'fa', up: 'fa-sort-asc', down: 'fa-sort-desc', is: 'fa-sort' },
            perPage: 20
        }
    },
    computed: {
        selectTypeDDL: function() {
          var list = [...this.typeDDL]
          list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
          list.unshift({ value: '0' , text: '- Todos -' })
          return list
        },
        totalRows: function() { return this.getRowCount() },
        filteredItems() {
            try {
                return this.items.filter(item => {
                    return this.filters.key == '' || item.name.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1
                })
            } catch (e) {
                return this.items;
            }
        }
    },
    methods: {      
        handleResp(resp) {
            // Mantém a janela aberta ao incluir/alterar, para permitir vincular
            // endereços, documentos e demais informações da pessoa em seguida.
            if(resp && resp.isNew && resp.id) {
              this.selectedItem.id = resp.id
            }

            if(resp && resp.message) {
              toast ({
                type: VueNotifications.types.success,
                title: 'Pessoa',
                message: resp.message,
                timeout: 5000
              })
            }

            this.refreshData()
        },
        async getType() {
            var s = this
            var currentUser = this.$store.state.currentUser
            await axios.get(
                this.$store.state.ws_url + "/person/type/ddl?uid=" + currentUser.id + "&sid=" + currentUser.sid
                
            ).then(function(resp) {
            s.typeDDL = resp.data.obj;
            }).catch(function (error) {
            console.log(error);
            })
        },
        
     

        getRowCount: function() {
            return this.items.length
        },
       
        
        enableDisable() {
            console.log('Habilitando/desabilitando grupo de acesso')
            //console.log(this.selectedItem);
        },
        closeEditModal() {
            this.editModal = false;
        },
        openEditModal(item) {
            this.tabInfo = 'P'
            this.selectedItem = null
            if (item == null) {
                this.selectedItem = JSON.parse(JSON.stringify(this.newItem));
            } else {
                this.selectedItem = JSON.parse(JSON.stringify(item));
            }
            this.editModal = true;
        },
        onRowSelected(items) {
            this.selected = items
            //console.log(items);
            //this.openEditModal(items[0])
        },
        selectAllRows() {
            this.$refs.selectableTable.selectAllRows();
        },
        clearSelectedRows() {
            this.$refs.selectableTable.clearSelected();
        },
        rowClicked(item) {
                  if (!this.tableSelectable) {
                this.clearSelectedRows();
                this.openEditModal(item);
            }
        },
        getBadge(status) {
            return status === 'A' ? 'primary' :
                status === 'I' ? 'danger' :
                status === 'Pending' ? 'warning' :
                status === 'Banned' ? 'danger' : 'primary'
        },
        toggleBusy() {
            this.isBusy = !this.isBusy
        },
        filterChanged() {
          if(this.filters.key && this.filters.key.length >= 4)
            this.refreshData();
        },
        
        async getPersonType() {
          var s = this;
          var currentUser = this.$store.state.currentUser;

          await axios.get(
              this.$store.state.ws_url + "/person/type/ddlselect?uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function(resp) {
            s.personTypeDDL = resp.data.obj;
          }).catch(function(error) {
            
          })

        },
        async refreshData() {
            this.isBusy = true;

            var s = this;
            var currentUser = this.$store.state.currentUser;

                        await axios.get(
                this.$store.state.ws_url + "/person?companyId=" + s.filters.companyId + "&key=" + s.filters.key + "&typeId=" + s.filters.typeId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function(resp) {
              //s.items = resp.data.obj
              //console.log(resp.data.obj)
              s.items = s.$utils.mergeArrays(s.items, resp.data.obj, 'id');                    
            }).catch(function(error) {
              toast ({
                type: VueNotifications.types.error,
                title: 'Pessoa',
                message: 'Sem permissão de acesso.',
                timeout: 5000
              })
            })

            this.isBusy = false;
        
        },

        changeCompany() {
          this.refreshData()
        }
    },
    mounted: function() {
      this.companyDDL = this.$store.state.currentUser.companies
      this.filters.companyId = this.$store.state.currentUser.companyId  
      this.getPersonType()
      this.getType()     
      this.changeCompany()

    }
}
</script>

<style scoped>
table#table-transition-example .flip-list-move {
    transition: transform 1s;
}
</style>